module.exports = "<span class=\"error-message\"> {{ getMsg() }}</span>\n"